import { cn } from '@/_shared/lib/utils';

/**
 * Classes for the wrapper holding the always-on "Other" row AND its free-text box.
 *
 * The two are ONE control, so ONE element owns the block's fill, hover tint and focus ring. Drawing any
 * of them on the row alone drew it through the SEAM between the row and the box — a ring with a 2px
 * offset band cutting the block in half, and a hover tint that vanished the moment the pointer moved
 * from the row down onto the box it belongs to.
 *
 * The ring comes from `focus-ring-within-row` (app.css), the composite twin of `focus-ring`: it keys on the
 * row's own control (`data-other-row`) rather than a bare `:has(:focus-visible)`, because the box draws its
 * own ring on focus and the block must not double up on it.
 *
 * The DISABLED fade belongs here too, for the same reason the fill does. Put `opacity-50` on the row instead
 * and it cannot reach the block's `bg-accent` on the parent — a disabled-but-selected block then renders a
 * full-strength blue slab under half-faded contents, unlike every other row, where one element carries the
 * fill and the fade together. The children suppress their own (`disabled:opacity-100`) so the two do not
 * compound to 25%.
 *
 * Shared by both lists so the single- and multi-select blocks cannot drift.
 */
export function otherBlockClass(isSelected: boolean, isDisabled: boolean): string {
  return cn(
    'rounded-md transition-colors focus-ring-within-row',
    isSelected && 'bg-accent',
    isDisabled ? 'opacity-50' : !isSelected && 'hover:bg-muted',
  );
}
